import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { AnalyticsRecentClick } from "@/types/analytics";
import { format, parseISO, isValid } from "date-fns";
import { CopyableValue } from "@/components/clicks/CopyableValue";

// Short numeric date (01.10.2026) rather than the shared "01 October 2026".
const shortDate = (iso: string): string => {
  const d = parseISO(iso);
  return isValid(d) ? format(d, "dd.MM.yyyy") : iso;
};

interface RecentClicksTableProps {
  data: AnalyticsRecentClick[];
}

export const RecentClicksTable = ({ data }: RecentClicksTableProps) => {
  return (
    <Card className="mt-4">
      <CardHeader>
        <CardTitle>Recent Clicks</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[200px]">Date and time</TableHead>
              <TableHead>Campaign</TableHead>
              <TableHead>OS</TableHead>
              <TableHead>Bro</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>Destination</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map((click, index) => (
              <TableRow key={index}>
                <TableCell className="text-muted-foreground whitespace-nowrap">
                  {shortDate(click.datetime)}
                </TableCell>
                <TableCell className="font-medium">{click.campaign}</TableCell>
                <TableCell>{click.os}</TableCell>
                <TableCell>{click.browser}</TableCell>
                <TableCell className="font-mono text-sm text-[var(--chart-2-fg)] tabular-nums">
                  {click.ip}
                </TableCell>
                {/* Full URL, no truncation, click to copy. */}
                <TableCell className="font-mono text-sm">
                  <CopyableValue value={click.destination} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

